var _path, _path2, _path3, _path4, _circle, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBuy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-bg",
    d: "M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon-color",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 18C12.8954 18 12 18.8954 12 20V26C12 27.1046 12.8954 28 14 28H26C27.1046 28 28 27.1046 28 26V20C28 18.8954 27.1046 18 26 18H14ZM16.5 21C15.3954 21 14.5 21.8954 14.5 23C14.5 24.1046 15.3954 25 16.5 25H23.5C24.6046 25 25.5 24.1046 25.5 23C25.5 21.8954 24.6046 21 23.5 21H16.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "icon-path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 18.75C13.3096 18.75 12.75 19.3096 12.75 20V26C12.75 26.6904 13.3096 27.25 14 27.25H26C26.6904 27.25 27.25 26.6904 27.25 26V20C27.25 19.3096 26.6904 18.75 26 18.75H25V17.25H26C27.5188 17.25 28.75 18.4812 28.75 20V26C28.75 27.5188 27.5188 28.75 26 28.75H14C12.4812 28.75 11.25 27.5188 11.25 26V20C11.25 18.4812 12.4812 17.25 14 17.25H15V18.75H14Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "icon-path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 21.75C15.8096 21.75 15.25 22.3096 15.25 23C15.25 23.6904 15.8096 24.25 16.5 24.25H23.5C24.1904 24.25 24.75 23.6904 24.75 23C24.75 22.3096 24.1904 21.75 23.5 21.75H23V20.25H23.5C25.0188 20.25 26.25 21.4812 26.25 23C26.25 24.5188 25.0188 25.75 23.5 25.75H16.5C14.9812 25.75 13.75 24.5188 13.75 23C13.75 21.4812 14.9812 20.25 16.5 20.25H17V21.75H16.5Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 17,
    r: 5,
    fill: "white",
    stroke: "#E98000",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "icon-path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 12.75C17.6528 12.75 15.75 14.6528 15.75 17C15.75 19.3472 17.6528 21.25 20 21.25C22.3472 21.25 24.25 19.3472 24.25 17C24.25 14.6528 22.3472 12.75 20 12.75ZM14.25 17C14.25 13.8244 16.8244 11.25 20 11.25C23.1756 11.25 25.75 13.8244 25.75 17C25.75 20.1756 23.1756 22.75 20 22.75C16.8244 22.75 14.25 20.1756 14.25 17Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "icon-path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2724 14.8181C18.3559 14.4842 18.6559 14.25 19 14.25H20.5C20.8231 14.25 21.318 14.3107 21.7621 14.5239C22.2236 14.7454 22.75 15.206 22.75 16C22.75 16.794 22.2236 17.2546 21.7621 17.4761C21.318 17.6893 20.8231 17.75 20.5 17.75H19.0856L18.7276 19.1819C18.6271 19.5837 18.2199 19.8281 17.8181 19.7276C17.4163 19.6271 17.1719 19.2199 17.2724 18.8181L18.2724 14.8181ZM19.4606 16.25H20.5C20.6769 16.25 20.932 16.2107 21.113 16.1239C21.1978 16.0831 21.2325 16.048 21.2428 16.0348C21.243 16.0345 21.2433 16.0342 21.2435 16.0339C21.2458 16.0315 21.25 16.0272 21.25 16C21.25 15.9728 21.2458 15.9685 21.2435 15.9661C21.2433 15.9658 21.243 15.9655 21.2428 15.9652C21.2325 15.952 21.1978 15.9169 21.113 15.8761C20.932 15.7893 20.6769 15.75 20.5 15.75H19.5856L19.4606 16.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBuy);
export default __webpack_public_path__ + "static/media/icon-buy.68ccbad4570b93008d79fec47e16c0ef.svg";
export { ForwardRef as ReactComponent };